angular.module('impactx.workspace').controller('WorkspaceSwitchCtrl', [
    '$workspace',
    'ThemeWorldService',
    '$context',
    '$timeout',
    '$config',
    'sidebarShow',
    WorkSpaceSwitchController
]);

function WorkSpaceSwitchController($workspace, ThemeWorldService, $context, $timeout, $config, sidebarShow) {
    var self = this;
    var workspaceMenuPromise;
    self.showWorkspaceMenu = false;

    self.getWorkspaces = function () {
        return $workspace.getWorkspaces();
    };

    self.hasMoreWorkspaces = function () {
        return $workspace.hasOtherWorkspaces();
    };

    self.isCurrentWorkspace = function (workspace) {
        var workspaceKey = impactX.isDefined(workspace, 'key');
        if (workspaceKey) {
            return workspaceKey == $workspace.getCurrentWorkspace().key;
        }
    };

    self.hideWorkspaceMenu = function () {
        workspaceMenuPromise = $timeout(function () {
            self.showWorkspaceMenu = false;
        }, 1000);
    };

    self.toggleWorkspaceMenu = function () {
        self.showWorkspaceMenu = !self.showWorkspaceMenu;
    };

    self.getTheme = function (workspace) {
        if($workspace.getHighContrastActive()) {
            return $workspace.getHighContrastKey();
        }

        if (workspace.key === "shop" && ThemeWorldService.getCurrentThemeWorldSearch()) {
            return ThemeWorldService.getCurrentThemeWorldSearch();
        }
        else {
            return workspace.key + $context.getSuffixForTheme();
        }
    };

    self.getIconClass = function (workspace) {
        return $config.getIconClass(workspace);
    };

    self.activate = function (workspace) {
        $workspace.activateWorkspace(workspace, true);
        self.showWorkspaceMenu = false;
    };

    self.cancelWorkspaceMenuPromise = function () {
        $timeout.cancel(workspaceMenuPromise);
    };

    self.isOpen = function () {
        return sidebarShow.isOpen();
    };
}